import { create } from 'zustand';

interface RoomState {
  roomId: string | null;
  displayName: string | null;
  isHost: boolean;
  inLobby: boolean;
  joinedRoom: boolean;
  password: string | null;
  
  setRoomId: (roomId: string) => void;
  setDisplayName: (name: string) => void;
  setIsHost: (isHost: boolean) => void;
  setInLobby: (inLobby: boolean) => void;
  setJoinedRoom: (joined: boolean) => void;
  setPassword: (password: string | null) => void;
  reset: () => void;
}

export const useRoomStore = create<RoomState>((set) => ({
  roomId: null,
  displayName: null,
  isHost: false,
  inLobby: true,
  joinedRoom: false,
  password: null,
  
  setRoomId: (roomId) => set({ roomId }),
  setDisplayName: (name) => {
    localStorage.setItem('displayName', name);
    set({ displayName: name });
  },
  setIsHost: (isHost) => set({ isHost }),
  setInLobby: (inLobby) => set({ inLobby }),
  setJoinedRoom: (joined) => set({ joinedRoom: joined }),
  setPassword: (password) => set({ password }),
  reset: () => set({
    roomId: null,
    displayName: localStorage.getItem('displayName') || null,
    isHost: false,
    inLobby: true,
    joinedRoom: false,
    password: null,
  }),
}));
